import { render, staticRenderFns } from "./AccountDeleted.vue?vue&type=template&id=20092176"
import script from "./AccountDeleted.vue?vue&type=script&lang=ts"
export * from "./AccountDeleted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports